import { connect } from "react-redux";
import GuestGuard from "../components/Auth/GuestGuard";

const mapStatetoProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  affiliateCode: state.auth.affiliateCode,
  relationalType: state.auth.relationalType,
  userSourceCode: state.auth.userSourceCode,
  otpFlag: state.auth.otpFlag,
  email: state.auth.email
})

const GuestGuardContainer = connect(mapStatetoProps, {})(GuestGuard);

export default GuestGuardContainer;
